import { render, staticRenderFns } from "./AiChooseComp.vue?vue&type=template&id=ffd9151a&scoped=true"
import script from "./AiChooseComp.vue?vue&type=script&lang=js"
export * from "./AiChooseComp.vue?vue&type=script&lang=js"
import style0 from "./AiChooseComp.vue?vue&type=style&index=0&id=ffd9151a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd9151a",
  null
  
)

export default component.exports